module.exports = __webpack_public_path__ + "img/Agradecimiento_Feria_del_Trabajo_2023.a19c7ee8.png";